import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapAtmToApiAtmDto = (values: IEditAtmForm): IPostEditAtm | {} => {
  let dataMapping: IPostEditAtm;
  const unknown = -1;

    dataMapping = {
      description: values.description,
      atmAddress: values.atmAddress,
      atmHost: values.atmHost,
      unitID: +values.unitID,
      lineTypeID: +values.lineTypeID !== 0 ? +values.lineTypeID : unknown,
      modemID: +values.modemID !== 0 ? +values.modemID : unknown,
      atmTypeID: +values.atmTypeID !== 0 ? +values.atmTypeID : unknown,
      atmTerm: values.atmTerm,
      connMethod: values.connMethod,
      contact: values.contact,
      atmModelID: +values.atmModelID !== 0 ? +values.atmModelID : unknown,
      atmCompany: +values.atmCompany !== 0 ? +values.atmCompany : unknown,
      isEmporiki: values.isEmporiki,
      isCiti: values.isCiti,
      lineEndID: +values.lineEndID !== 0 ? +values.lineEndID : unknown,
      //gpsid: +values.gpsid !== 0 ? +values.gpsid : unknown,
      //littleBoxSerial: values.littleBoxSerial !== "" ? values.littleBoxSerial : null,
      //isdnid: +values.isdnid !== 0 ? +values.isdnid : unknown,
      //bsimid: +values.bsimid !== 0 ? +values.bsimid : unknown,
      comments: values.comments !== "" ? values.comments : null

      
    }
  
  return dataMapping;
}


const editAtm = ( {data, atmId} : {data: IEditAtmForm , atmId: number}): Promise<string> => {
  const atm = mapAtmToApiAtmDto(data);
  return axiosDefaultApi.put(`/api/Atm/UpdateAtm/${atmId}`, atm);
};

type QueryFnType = typeof editAtm;

type UseEditAtmOptions = {
  data: IPostEditAtm | {};
  atmId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditAtm = ({ config }: UseEditAtmOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του ΑΤΜ.`, 500);
            console.error('Couldnt edit Atm', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtms"])
            addNotification('Το ΑΤΜ Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editAtm,
    })
}